<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="实时电位"></a-tab-pane>
        <a-tab-pane key="2" tab="历史电位"></a-tab-pane>
        <a-tab-pane key="3" tab="实时交流电压"></a-tab-pane>
        <a-tab-pane key="4" tab="历史交流电压"></a-tab-pane>
        <a-tab-pane key="5" tab="季度电位分析"></a-tab-pane>
        <a-tab-pane key="6" tab="管线电位/交流电压分布"></a-tab-pane>
        <a-tab-pane key="7" tab="电流分布图"></a-tab-pane>
      </a-tabs>
      <div v-if='showType==1'>
        <div ref="echartsOne" style="width: 100%; height: 600px;"></div>
      </div>
      <div v-if='showType==2'>2
        <div ref="echartsTwo" style="width: 100%; height: 600px;"></div>
      </div>
      <div v-if='showType==3'>3
        <div ref="echartsThree" style="width: 100%; height: 600px;"></div>
      </div>
      <div v-if='showType==4'>4
        <div ref="echartsFour" style="width: 100%; height: 600px;"></div>
      </div>
      <div v-if='showType==5'>5
        <div ref="echartsFive" style="width: 100%; height: 600px;"></div>
      </div>
      <div v-if='showType==6'>6
        <div ref="echartsSix" style="width: 100%; height: 600px;"></div>
      </div>
      <div v-if='showType==7'>7
        <div ref="echartsSeven" style="width: 100%; height: 600px;"></div>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { listChartOne, listChartTwo, listChartThree, listChartFour, listChartFive, listChartSix, listChartSeven } from '@/api/saifuneng/devicedata'
import * as echarts from 'echarts'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Setup',
  components: {

  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data () {
    return {
      showType: 1,
      listChartOne: [],
      listChartTwo: [],
      listChartThree: [],
      listChartFour: [],
      listChartFive: [],
      listChartSix: [],
      listChartSeven: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParam: {
        type: null
      }
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    // this.echartsOne = echarts.init(this.$refs.echartsOne)
    // this.echartsTwo = echarts.init(this.$refs.echartsTwo)
    // this.echartsThree = echarts.init(this.$refs.echartsThree)
    // this.echartsFour = echarts.init(this.$refs.echartsFour)
    // this.echartsFive = echarts.init(this.$refs.echartsFive)
    // this.echartsSix = echarts.init(this.$refs.echartsSix)
    // this.echartsSeven = echarts.init(this.$refs.echartsSeven)
  },
  methods: {
    /** 查询数据信息列表 */
    getList () {
      listChartOne(this.queryParam).then(response => {
        this.list = response.data
      })
    },
    echartsOne: null,
    echartsTwo: null,
    echartsThree: null,
    echartsFour: null,
    echartsFive: null,
    echartsSix: null,
    echartsSeven: null,
    optionOne: {},
    optionTwo: {},
    optionThree: {},
    optionFour: {},
    optionFive: {},
    optionSix: {},
    optionSeven: {},

    echartsInitOne() {
      this.echartsOne = echarts.init(this.$refs.echartsOne)
      this.optionOne = {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line'
          }
        ]
      }
      this.echartsOne.setOption(this.optionOne)
    },
    echartsInitTwo() {
      this.echartsTwo = echarts.init(this.$refs.echartsTwo)
      this.echartsOne = null
      // 初始化容器
      // const chartTwo = echarts.init(this.$refs.echartsTwo)
      // const option = {这里面就是图表的各种配置项，从官方文档搞下来};
      // chartTwo.setOption(option);
    },
    echartsInitThree() {
      // 初始化容器
      // const chartThree = echarts.init(this.$refs.echartsThree)
      // const option = {这里面就是图表的各种配置项，从官方文档搞下来};
      // chartThree.setOption(option);
    },
    echartsInitFour() {
      // 初始化容器
      // const chartFour = echarts.init(this.$refs.echartsFour)
      // const option = {这里面就是图表的各种配置项，从官方文档搞下来};
      // chartFour.setOption(option);
    },
    echartsInitFive() {
      // 初始化容器
      // const chartFive = echarts.init(this.$refs.echartsFive)
      // const option = {这里面就是图表的各种配置项，从官方文档搞下来};
      // chartFive.setOption(option);
    },
    echartsInitSix() {
      // 初始化容器
      // const chartSix = echarts.init(this.$refs.echartsSix)
      // const option = {这里面就是图表的各种配置项，从官方文档搞下来};
      // chartSix.setOption(option);
    },
    echartsInitSeven() {
      // 初始化容器
      // const chartSeven = echarts.init(this.$refs.echartsSeven)
      // const option = {这里面就是图表的各种配置项，从官方文档搞下来};
      // chartSeven.setOption(option);
    },

    // 页签切换
    callback(key) {
      if (key === '1') {
        this.showType = 1
        // 初始化图表
        this.echartsInitOne()
      } else if (key === '2') {
        this.showType = 2
        this.echartsInitTwo()
      } else if (key === '3') {
        this.showType = 3
        this.echartsInitThree()
      } else if (key === '4') {
        this.showType = 4
        this.echartsInitFour()
      } else if (key === '5') {
        this.showType = 5
        this.echartsInitFive()
      } else if (key === '6') {
        this.showType = 6
        this.echartsInitSix()
      } else if (key === '7') {
        this.showType = 7
        this.echartsInitSeven()
      }
      // this.getList()
    }

  }
}
</script>
